import { useInView } from '../../../hooks/useInView';

const valores = [
  { icon: 'ri-shield-check-line', title: 'Honestidad', desc: 'Presupuesto transparente antes de iniciar cualquier trabajo. Sin sorpresas, sin cargos ocultos.' },
  { icon: 'ri-award-line', title: 'Calidad', desc: 'Solo utilizamos piezas originales o de primera calidad, con garantía total en cada intervención.' },
  { icon: 'ri-user-heart-line', title: 'Cercanía', desc: 'Te explicamos qué le pasa a tu coche en lenguaje sencillo. Somos tu taller de confianza.' },
  { icon: 'ri-time-line', title: 'Compromiso', desc: 'Cumplimos los plazos acordados. Tu tiempo es tan valioso como el nuestro.' },
  { icon: 'ri-tools-line', title: 'Profesionalismo', desc: 'Equipo de técnicos con formación continua en las últimas tecnologías del sector.' },
  { icon: 'ri-recycle-line', title: 'Responsabilidad', desc: 'Gestión responsable de residuos y compromiso con el medio ambiente en todos nuestros procesos.' },
];

const Valores = () => {
  const [headerRef, headerInView] = useInView();
  const [gridRef, gridInView] = useInView(0.05);

  return (
    <section className="bg-black py-20 px-6">
      <div className="max-w-7xl mx-auto">

        <div
          ref={headerRef}
          className={`mb-12 transition-all duration-700 ${
            headerInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="w-5 h-px bg-yellow-400" />
            <span className="text-yellow-400 text-[10px] font-bold uppercase tracking-[0.3em]">Lo que nos define</span>
          </div>
          <h2 className="font-display text-5xl md:text-6xl uppercase text-white leading-none tracking-wide">
            Nuestros <span className="text-yellow-400">Valores</span>
          </h2>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {valores.map((v, i) => (
            <div
              key={v.title}
              className={`group bg-zinc-900/60 border border-zinc-800 hover:border-yellow-400/25 hover:bg-yellow-400/4 p-7 transition-all duration-500 cursor-default ${
                gridInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${i * 0.08}s`, transitionDuration: '600ms' }}
            >
              <div className="w-10 h-10 flex items-center justify-center bg-yellow-400/10 border border-yellow-400/15 text-yellow-400 mb-5 group-hover:bg-yellow-400/15 transition-colors">
                <i className={`${v.icon} text-sm`} />
              </div>
              <h3 className="text-white text-sm font-bold uppercase tracking-wide mb-2">{v.title}</h3>
              <p className="text-zinc-500 text-sm leading-relaxed font-light">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Valores;
